import React from 'react'
import { ReactSVG } from 'react-svg'
import * as styles from './ClientGrid.module.scss'
import classNames from 'classnames'

export type ClientLogo = {
  src: string
  description?: string[]
}

type ClientGridProps = {
  title?: string
  logos?: ClientLogo[]
  hideTitle?: boolean
  clientGridSectionClassName?: string
  showDescriptionsOnHover?: boolean
  tieredLayout?: boolean // If true, the logos will be displayed in a grid (8 col desktop | 4 col tablet | 2 mobile)
}

const defaultTitle = 'Powering 3,000+ of the world’s most effective teams'
// Define paths to SVGs
const defaultLogos: ClientLogo[] = [
  { src: '/assets/logos/clients/ADP.svg' },
  { src: '/assets/logos/clients/Amazon.svg' },
  { src: '/assets/logos/clients/Deel.svg' },
  { src: '/assets/logos/clients/Augeo.svg' },
  { src: '/assets/logos/clients/Clickup.svg' },
  { src: '/assets/logos/clients/Benevity.svg' },
  { src: '/assets/logos/clients/Flexport.svg' },
  { src: '/assets/logos/clients/Fmx.svg' },
  { src: '/assets/logos/clients/Goldcast.svg' },
  { src: '/assets/logos/clients/Hubspot.svg' },
  { src: '/assets/logos/clients/Beauty-bay.svg' },
  { src: '/assets/logos/clients/Buildops.svg' },
  { src: '/assets/logos/clients/Sage.svg' },
  { src: '/assets/logos/clients/Cadmium.svg' },
  { src: '/assets/logos/clients/Infor.svg' },
  { src: '/assets/logos/clients/Deputy.svg' },
  { src: '/assets/logos/clients/Finexio.svg' },
  { src: '/assets/logos/clients/Toast.svg' },
  { src: '/assets/logos/clients/Lime.svg' },
  { src: '/assets/logos/clients/Mosaic.svg' },
  { src: '/assets/logos/clients/Jobber.svg' },
  { src: '/assets/logos/clients/Ridgeline.svg' },
  { src: '/assets/logos/clients/Linklaters.svg' },
  { src: '/assets/logos/clients/Sellsy.svg' }
]

const ClientGrid: React.FC<ClientGridProps> = ({
  title = defaultTitle,
  logos = defaultLogos,
  clientGridSectionClassName,
  hideTitle = false,
  showDescriptionsOnHover = false,
  tieredLayout = false
}) => {
  return (
    <section
      className={`${styles.container} ${clientGridSectionClassName || ''}`}
    >
      {!hideTitle && <h2>{title}</h2>}
      <div
        className={classNames(styles.grid, {
          [styles.tieredCols]: tieredLayout
        })}
      >
        {logos.map((logo, index) => (
          <div
            key={index}
            className={classNames(styles.logo, {
              [styles.hoverText]: showDescriptionsOnHover,
              [styles.tieredLayout]: tieredLayout
            })}
          >
            <ReactSVG src={logo.src} />
            {showDescriptionsOnHover && logo.description && (
              <div className={styles.description}>
                {logo.description.map((desc, i, arr) => (
                  <React.Fragment key={i}>
                    <span>{desc}</span>
                    {i === 0 && arr.length > 1 && <hr />}
                  </React.Fragment>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  )
}

export default ClientGrid
